export const TASK_UNCHECKED_EMOJI = "▢";

export const TASK_CHECKED_EMOJI = "✓";
